export default import.meta.ROLLUP_FILE_URL_0OpjfOOhJ2kW16kLP4OZgg